import React, {
  useLayoutEffect,
  Suspense,
  lazy,
} from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import { Custom } from "../Helpers/ThemeCustomization";
import { AuthRouter, Redirect } from "./AuthRouter";
// import DashboardLayout from "../Layout/DashboardLayout";
import { authRoutes } from "./Route";
// import NoPage from "../Component/NoPage/NoPage";
// import Login from "../Component/Login/Login";
//lazy loading
const DashboardLayout = lazy(() => import("../Layout/DashboardLayout"));
const NoPage = lazy(() => import("../Component/NoPage/NoPage"));
const Login = lazy(() => import("../Component/Login/Login"));
const Wrapper = ({ children }) => {
  const location = useLocation();
  useLayoutEffect(() => {
    document.documentElement.scrollTo(500, 0);
  }, [location.pathname]);
  return children;
};

const index = () => {
  return (
    <ConfigProvider
      theme={{
        token: Custom,
      }}
    >
      <Router>
        {/* <Suspense fallback={<div className="loading_flash">
          <Spin />
        </div>}> */}
        <Wrapper>
          <Routes>
            <Route path="/login" element={<Redirect><Suspense fallback={<div className="loading_flash">
              <Spin />
            </div>}><Login /></Suspense></Redirect>} />
            <Route
              path="/"
              element={
                <AuthRouter>
                  <DashboardLayout />
                </AuthRouter>
              }
            >
              {authRoutes !== null && authRoutes?.map((item, index) => {
                return (
                  <Route
                    key={index}
                    path={item?.path}
                    element={<Suspense fallback={<div className="loading_flash">
                      <Spin />
                    </div>}><AuthRouter>{item?.element}</AuthRouter></Suspense>}
                  />
                );
              })}
              <Route path="*" element={<Suspense fallback={<div className="loading_flash">
                <Spin />
              </div>}><NoPage /></Suspense>} />
            </Route>
            <Route path="*" element={<Suspense fallback={<div className="loading_flash">
              <Spin />
            </div>}><NoPage /></Suspense>} />
          </Routes>
        </Wrapper>
        {/* </Suspense> */}
      </Router>
    </ConfigProvider>
  );
};

export default index;
